









import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import AccountBalanceStackedChart from "@/employee/components/landing-pages/accountSummaryDashboard/AccountBalanceStackedChart.vue";


@Component({
  components: {
    AccountBalanceStackedChart,
  }
})
export default class NotionalBalanceLineChart extends Vue {
  hsabAccountsStore = useHsabAccountsStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop({ required: true })
  accountId: number;

  @Prop()
  containerClasses: string[];

  @Prop({ default: 220 })
  height: number;

  get balanceRecords (): any {
    return this.hsabAccountsStore.notionalBalances[this.accountId].records;
  }

  get hasData () {
    return this.hsabAccountsStore.allNotionalBalances &&
        this.hsabAccountsStore.allNotionalBalances[this.accountId] &&
        this.hsabAccountsStore.allNotionalBalances[this.accountId].records.length > 0;
  }

  @Watch("accountId")
  loadDailyBalances () {
    this.hsabAccountsStore.getNotionalBalances(this.accountId);
  }

  mounted () {
    this.hsabAccountsStore.getNotionalBalances(this.accountId);
  }
}
